import { Portfolio } from "../models/portfolio/portfolio";
import { BaseWebService } from "./base.web.service";

export class PortfolioWebService extends BaseWebService {
   
    // Inclusion Requests

    public async postInclusionRequest(portfolioId: string, infplId: string, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/inclusion-request`;
        const body = {
            portfolioId,
            infplId
        };
        return this.makeRequest(url, 'POST', headers, body);
    }

    public async deleteInclusionRequest(inclusionRequestId: string, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/inclusion-request/${inclusionRequestId}`;
        return this.makeRequest(url, 'DELETE', headers, undefined, 0, true);
    }

    public async putInclusionRequest(status: string, inclusionRequestId: string, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/inclusion-request/${inclusionRequestId}`;
        const body = {
            status
        };
        return this.makeRequest(url, 'PUT', headers, body, 0, true);
    }

    public async putInclusionRequestAfstemmingstatus(planAfstemmingsStatus: string, inclusionRequestId: string, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/inclusion-request/${inclusionRequestId}/planafstemmingsstatus`;
        const body = {
            planAfstemmingsStatus
        };
        return this.makeRequest(url, 'PUT', headers, body, 0, true);
    }

    public async getInclusionRequestArchived(inclusionRequestId: string, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/archived-inclusion-request/${inclusionRequestId}`;
        return this.makeRequest(url, 'GET', headers);
    }


    // Plan

    public async getPortfoliosByPlan(infplId: string, organizationId: string, listParams: any) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/plan/${infplId}/portfolio${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    // Portfolio 
    
    public async postPortfolio(portfolio: Portfolio, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/portfolio`;
        const body = portfolio;
        return this.makeRequest(url, 'POST', headers, body);
    }

    public async putPortfolio(portfolio: Portfolio, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/portfolio/${portfolio.id}`;
        const body = portfolio;
        return this.makeRequest(url, 'PUT', headers, body, 0, true);
    }

    public async getPortfolios(organizationId: string, listParams: any) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/portfolio${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getPortfolio(portfolioId: string, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/portfolio/${portfolioId}`;
        return this.makeRequest(url, 'GET', headers, undefined, 0, true); // TODO: bubble up dan verwerken in component wat er mee te doen.
    }

    public async getPortfolioArchived(portfolioId: string, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/archived-portfolio/${portfolioId}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getConsortiums(organizationId: string, listParams?: any): Promise<any> {
        const params = listParams ? this.createListParams(listParams) : '';
        const headers = {
            ...(await this.getHeadersJson()),
            'X-Organization-ID': organizationId,
        };
        const url = `${this.appConfig.servicePortfolioUrl}/api/v2/consortiums${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getConsortium(organizationId: string, consortiumId: string): Promise<any> {
        const headers = {
            ...(await this.getHeadersJson()),
            'X-Organization-ID': organizationId,
        };
        const url = `${this.appConfig.servicePortfolioUrl}/api/v1/consortiums/${consortiumId}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async addConsortiumToPortfolio(portfolioId: string, consortiumId: string, organizationId: string) {
        const headers = {
            ...(await this.getHeadersJson()),
            'X-Organization-ID': organizationId,
        };
        const url = `${this.appConfig.servicePortfolioUrl}/api/v1/portfolio/${portfolioId}/consortiums/${consortiumId}`;
        return this.makeRequest(url, 'PUT', headers, undefined, 0, true);
    }

    public async removeConsortiumFromPortfolio(portfolioId: string, consortiumId: string, organizationId: string) {
        const headers = {
            ...(await this.getHeadersJson()),
            'X-Organization-ID': organizationId,
        };
        const url = `${this.appConfig.servicePortfolioUrl}/api/v1/portfolio/${portfolioId}/consortiums/${consortiumId}`;
        return this.makeRequest(url, 'DELETE', headers, undefined, 0, true);
    }

    // Annotations 
    
    public async postAnnotation(annotation: any, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/annotation`;
        const body = annotation;
        return this.makeRequest(url, 'POST', headers, body);
    }

    public async putAnnotation(annotation: any, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/annotation/${annotation.id}`;
        const body = annotation;
        return this.makeRequest(url, 'PUT', headers, body, 0, true);
    }

    public async getAnnotationChildren(annotationId: string, organizationId: string, listParams: any) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/annotation/${annotationId}/annotation${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getAnnotationsByPortfolio(portfolioId: string, organizationId: string, listParams: any) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/portfolio/${portfolioId}/annotation${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getAnnotationsByTask(taskId: string, organizationId: string, listParams: any) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/task/${taskId}/annotation${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getAnnotationsArchived(annotationId: string, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/archived-annotation/${annotationId}`;
        return this.makeRequest(url, 'GET', headers);
    }

    // Tasks 
    
    public async postTask(task: any, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/tasks`;
        const body = task;
        return this.makeRequest(url, 'POST', headers, body);
    }

    public async putTask(task: any, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/tasks/${task.id}`;
        const body = task;
        return this.makeRequest(url, 'PUT', headers, body, 0, true);
    }

    public async getTasksByPortfolio(portfolioId: string, organizationId: string, listParams: any) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/portfolio/${portfolioId}/tasks${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getTasksArchived(taskId: string, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePortfolioUrl}/api/${organizationId}/archived-tasks/${taskId}`;
        return this.makeRequest(url, 'GET', headers);
    }
}